import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';
import AngularHelperService from '../services/angular-helper.service';
import AngularBroadcastHelperService from '../services/angular-broadcast-helper.service';

@Injectable({ providedIn: 'root' })
export default class ConciergeService {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	getBookingPreliminaryCheck(businessServiceId) {
		return this.fetchBookingPreliminaryCheck(businessServiceId);
	}
	
	fetchBookingPreliminaryCheck(businessServiceId) {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		var url: any = this.config.getRestUrl()
			+ 'rest/booking/preliminary/check/result?businessServiceId=' + businessServiceId
			+ '&platform=BROWSER';
		
		this.httpClient.get(url, { withCredentials: true }).toPromise()
			.then((response) => {
				if (response) {
					this.angularBroadcastHelperService.rootBroadcast('FS.' + url + '.fetching.success', response);
					deferred.resolve(response);
				}
			})
			.catch((err) => {
				console.error('Fetching service failed to fetch from ' + url + ', error: ' + err);
				this.angularBroadcastHelperService.rootBroadcast('FS.' + url + '.fetching.error', err);
				deferred.reject(err);
			});
		
		return deferred.promise;
	}
	
}